import { useEffect, useState } from 'react';
import { useUser } from '../../../hooks/use-user';
import { UserRole, UserType } from '../../../lib/interfaces/user';
import SearchInput from '../../../ui/components/ui/search-input';
import BonusPayments from './bonus-payments';
import CustomerOverview from './customer-overview';
import { FullBonus, FullBonusSmall } from './full-bonus';
import { Leaderboard, LeaderboardTop4 } from './leaderboard';
import EmployeeNotifications from './notifications';
import { useNavigate } from 'react-router-dom';
import Preloader from '../../../ui/components/ui/preloader';

const DashboardBonus = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchQuery, setSearchQuery] = useState('');
  const { user } = useUser();
  const isUser = !(user?.userRole === UserRole.Admin || user?.userRole === UserRole.SuperAdmin || user?.isTeamLeader);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;

    if (user.userType === UserType.Customer) {
      navigate('/', { replace: true });
      return;
    }

    setIsLoading(false);
  }, [user, navigate]);

  if (isLoading) {
    return <Preloader />;
  }

  let heading = 'Bonus';
  let description = 'Bonus aller Mitarbeiter';
  if (isUser) {
    heading = 'Dashboard';
    description = 'Alles im Blick';
  }

  return (
    <div className="flex flex-col gap-5 h-full">
      <div className="flex justify-between">
        <div>
          <h1 className="text-[32px] leading-[38px] font-bold text-[#12282A]">{heading}</h1>
          <p className="text-[16px] text-[#888]">{description}</p>
        </div>
        {!isUser && (
          <div className="flex gap-2">
            <SearchInput setSearchText={setSearchQuery} searchText={searchQuery} />
          </div>
        )}
      </div>
      {isUser ? <BonusDashboard /> : <BonusDashboardAdmin textSearch={searchQuery} />}
    </div>
  );
};

const BonusDashboardAdmin = ({ textSearch }: { textSearch: string }) => {
  return (
    <div className="flex flex-col gap-6">
      <div className="w-full flex gap-6 max-h-56">
        <FullBonusSmall />
        <Leaderboard />
      </div>
      <div className="w-full flex gap-6">
        <BonusPayments textSearch={textSearch} />
      </div>
      <div className="w-full flex gap-6">
        <CustomerOverview isAdmin={true} />
      </div>
    </div>
  );
};

const BonusDashboard = () => {
  return (
    <div className="flex flex-col gap-6">
      <CustomerOverview isAdmin={false} />
      <div className="w-full flex gap-6">
        <LeaderboardTop4 />
        <FullBonus />
      </div>
      <EmployeeNotifications />
    </div>
  );
};

export default DashboardBonus;
